import { render } from "./AddCommissionRecord.vue?vue&type=template&id=75343bc7&scoped=true&ts=true"
import script from "./AddCommissionRecord.vue?vue&type=script&lang=ts"
export * from "./AddCommissionRecord.vue?vue&type=script&lang=ts"

import "./AddCommissionRecord.vue?vue&type=style&index=0&id=75343bc7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75343bc7"]])

export default __exports__